import React, { FunctionComponent, memo, useRef, useState } from 'react'

import { SpaceProps } from 'styled-system'

import InfoIcon from '@/atoms/icons/info.svg'
import WarningIcon from '@/atoms/icons/warning.svg'
import { Tooltip } from '@/atoms/tooltip'

import { InfoTooltipWrapper } from './styled-info-tooltip'

interface Props {
  tooltipText: string
  variant?: 'info' | 'warning'
}

const InfoTooltip: FunctionComponent<Props & SpaceProps> = memo(({ tooltipText, variant = 'info', ...spaceProps }) => {
  const iconRef = useRef(null)
  const [isTooltipVisible, setTooltipVisibility] = useState(false)

  const isInfo = variant === 'info'

  return (
    <InfoTooltipWrapper
      ref={iconRef}
      onMouseEnter={() => setTooltipVisibility(true)}
      onMouseLeave={() => setTooltipVisibility(false)}
      {...spaceProps}
    >
      {isInfo ? <InfoIcon width="14px" height="14px" viewBox="0 0 24 24" /> : <WarningIcon width="14px" height="14px" />}
      <Tooltip isVisible={isTooltipVisible} targetRef={iconRef} title={tooltipText} />
    </InfoTooltipWrapper>
  )
})

InfoTooltip.displayName = 'InfoTooltip'

export default InfoTooltip
